import { useTranslation } from "react-i18next"

import {
  useWorkspaceDefinition,
  type Workspace,
} from "@/components/workspace/definition"

import type { Crumb } from "./breadcrumb-strip"

// The root of every workspace trail: the workspace the page belongs to (a
// teacher's, a school's or a student's), which the page knows from its own
// route, whoever is viewing it. Its path comes from the owner type's
// definition, which the composition root provides.
export function useWorkspaceCrumb({ ownerType, ownerId }: Workspace): Crumb {
  const { t } = useTranslation("nav")
  const { root } = useWorkspaceDefinition(ownerType)

  return { label: t("workspace"), href: root(ownerId) }
}

// A page's ancestors: its workspace's crumb, then the crumbs the page names.
// A page with no ancestors of its own passes none and gets the workspace
// alone.
export function useTrail(workspace: Workspace, ...crumbs: Crumb[]): Crumb[] {
  return [useWorkspaceCrumb(workspace), ...crumbs]
}
